export interface PartnerConditionLogUser {
  id: string;
  name: string;
  email: string;
}

export type PartnerConditionLogSource = 'manual' | 'automatic';

export interface PartnerConditionLog {
  id: string;
  field: string;
  old_value: string | null;
  new_value: string | null;
  created_at: string;
  source: PartnerConditionLogSource;
  user: PartnerConditionLogUser | null;
}

export interface ListPartnerConditionLogsResponse {
  data: PartnerConditionLog[];
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export const PARTNER_CONDITION_FIELD_LABELS: Record<string, string> = {
  type: 'Tipo de partner',
  comments: 'Comentarios',
  relationship_type: 'Tipo de relación',
  distribution_modality: 'Modalidad de distribución',
  fixed_commission: 'Comisión fija',
  recurring_commission: 'Comisión recurrente',
  operation_limit: 'Límite de operación',
  settlement_periodicity: 'Periodicidad de liquidación',
  min_new_clients_per_year: 'Mínimo clientes nuevos/año',
  status: 'Estado',
};
